import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { obtenerPeriodos } from '../../../../redux/DucksUnidadInspeccion/PeriodosDuck';
import { actualizarPeriodo } from '../../../../redux/DucksUnidadInspeccion/PeriodosDuck';
import { Edit } from '@mui/icons-material';

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

import { Formik, Form, Field, ErrorMessage } from 'formik';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import esLocale from "date-fns/locale/es";
import TextField from "@mui/material/TextField";

import { obtenerMesZona, actualizarInspector } from '../../../../redux/DucksUnidadInspeccion/MesZonaDuck';
import { getInspectores } from '../../../../redux/DucksUnidadInspeccion/InspectoresDuck';

import moment from 'moment'
import 'moment/locale/es'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    height: '75%',
};

const options = { weekday: "long", year: "numeric", month: "long", day: "numeric" };

function ConfiguracionPeriodos(props) {

    moment.locale('es')

    const dispatch = useDispatch();
    const periodosbase = useSelector(store => store.Periodos.periodos)
    const inspectores = useSelector(store => store.Inspectores.inspectores)
    //const zonasbase = useSelector(store => store.MesZona.zonas);
    const [zonasbase, setzonasbase] = React.useState([]);
    const [openActualizar, setOpenActualizar] = React.useState(false);
    const [editing, setEditing] = React.useState({});
    const [zonaSeleccionada, setZonaSeleccionada] = React.useState(1)
    const [inspectorSeleccionado, setinspectorSeleccionado] = React.useState(null)

    React.useEffect(() => {
        dispatch(obtenerPeriodos());
        dispatch(obtenerMesZona()).then((res) => {
            setzonasbase(res.payload.data.data)
        })
    }, [])


    React.useEffect(() => {
        editing
    }, [editing])

    React.useEffect(() => {
        zonasbase
    }, [zonasbase])

    const handleOpenActualizar = (m) => {
        setEditing(m)
        setOpenActualizar(true)
    }

    const handleCloseActualizar = () => {
        setOpenActualizar(false)
    }

    const modalActualizarPeriodo = () => {
        return (
            <Modal
                open={openActualizar}
                onClose={handleCloseActualizar}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Formik
                        initialValues={{
                            idperiodozona: editing.idperiodozona,
                            fechainicio: editing.fechainicio,
                            fechafin: editing.fechafin
                        }}
                        enableReinitialize={true}
                        validate={values => {
                            const errors = {};
                            return errors;
                        }}
                        onSubmit={(values) => {
                            if (inspectorSeleccionado != null) {
                                const data = {
                                    data: {
                                        idmeszona: editing.idmeszona,
                                        idinspector: Number(inspectorSeleccionado)
                                    }
                                }

                                dispatch(actualizarInspector(data)).then((res) => {
                                    setinspectorSeleccionado(null)

                                })
                            }
                            const data = {
                                data: {
                                    idperiodozona: editing.periodozona.idperiodozona,
                                    fechafin: editing.fechafin != undefined ? editing.fechafin : editing.periodozona.fechafin,
                                    fechainicio: editing.fechainicio != undefined ? editing.fechainicio : editing.periodozona.fechainicio
                                }
                            }

                            dispatch(actualizarPeriodo(data)).then((res) => {
                                dispatch(obtenerMesZona()).then((res) => {
                                    setzonasbase(res.payload.data.data)
                                    dispatch(obtenerPeriodos()).then((res) => {
                                        console.log("aaqui")
                                    })
                                    handleCloseActualizar()
                                    window.location.reload()
                                    //props.handleCerrarModalConfig()
                                })
                            })

                        }}
                    >

                        {({ values, isSubmitting }) => (
                            <Form>
                                <div style={{ textAlign: "center" }}>
                                    <h5>Editar Fecha Inicio y Fecha Fin <br /> del periodo {editing.periodozona.idperiodozona < 10 ? ("P0" + editing.periodozona.idperiodozona) : ("P" + editing.periodozona.idperiodozona)}</h5>
                                    <h6>(Configuracion Global)</h6>
                                    <br />
                                    <div className="form-group row">
                                        <label htmlFor="staticEmail" class="col-sm-4 col-form-label">Fecha de inicio</label>
                                        <div class="col-sm-6">
                                            <LocalizationProvider
                                                dateAdapter={AdapterDateFns}
                                                locale={esLocale}
                                            >
                                                <DatePicker
                                                    value={editing.fechainicio}
                                                    fullWidth
                                                    onChange={(newValue) => {
                                                        setEditing({
                                                            ...editing,
                                                            fechainicio: newValue
                                                        })
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            fullWidth
                                                            size="small"
                                                        />
                                                    )}
                                                />
                                            </LocalizationProvider>
                                        </div>
                                    </div>
                                    <br />
                                    <div className="form-group row">
                                        <label htmlFor="staticEmail" class="col-sm-4 col-form-label">Fecha de Fin</label>
                                        <div className="col-sm-6">
                                            <LocalizationProvider
                                                dateAdapter={AdapterDateFns}
                                                locale={esLocale}
                                            >
                                                <DatePicker
                                                    value={editing.fechafin}
                                                    fullWidth
                                                    onChange={(newValue) => {
                                                        setEditing({
                                                            ...editing,
                                                            fechafin: newValue
                                                        })
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            fullWidth
                                                            size="small"
                                                        />
                                                    )}
                                                />
                                            </LocalizationProvider>
                                            <br />
                                            <br />
                                        </div>
                                        <hr />
                                        <div>
                                            <h5>Inspector asignado al periodo {editing.periodozona.idperiodozona < 10 ? ("P0" + editing.periodozona.idperiodozona) : ("P" + editing.periodozona.idperiodozona)} <br /> de la zona: {editing.zona.nombrezona}</h5>
                                            <select name="inspector" className="form-select" onChange={(e) => setinspectorSeleccionado(e.target.value)}>
                                                <option defaultValue={""}>Seleccione un inspector</option>
                                                {inspectores.map((i, index) => (
                                                    <option key={index} value={i.idinspector}>{i.titulo}. {i.nombre} {i.apellidos}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <br />
                                    <button type='submit' className='btn btn-success'>Aceptar</button>
                                </div>
                            </Form>
                        )}

                    </Formik>
                </Box>
            </Modal>
        )
    }

    const handleZonaSeleccionada = (e) => {
        const { value } = e.target;
        setZonaSeleccionada(value);
    };

    return (
        <Fragment><br />
            <h4>Periodos</h4>
            <h5>Seleccione una Zona:

                <select
                    className="form-select mb-2"
                    aria-label=""
                    onChange={handleZonaSeleccionada}
                    name="zonaSeleccionada"
                    value={zonaSeleccionada}
                >
                    <option defaultValue>Seleccione la Zona</option>
                    {
                        zonasbase
                            .map((zona) => zona.zona)
                            .filter(
                                (zona, index, zonas) =>
                                    zonas.findIndex((z) => z.idzona === zona.idzona) === index
                            )
                            .map((zona, index) => (
                                <option key={index} value={zona.idzona}>
                                    {zona.nombrezona}
                                </option>
                            ))
                    }

                </select>
            </h5>
            <div className="table-responsive">
                <table className='table table-hover'>
                    <thead>
                        <tr>
                            <th>Identificador</th>
                            <th>Fecha de Inicio</th>
                            <th>Fecha de Fin</th>
                            <th>Inspector</th>
                            <th>Cadena Productiva</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {zonasbase.map((m, index) => (
                            m.zona.idzona == zonaSeleccionada ? (
                                <tr>
                                    <td>{m.periodozona.idperiodozona < 10 ? ("P0" + m.periodozona.idperiodozona) : ("P" + m.periodozona.idperiodozona)}</td>
                                    <td>{moment.utc(m.periodozona.fechainicio).format("LL")}</td>
                                    <td>{moment.utc(m.periodozona.fechafin).format("LL")}</td>
                                    <td>{m.inspector.nombre}</td>
                                    <td></td>
                                    <td><button type='button' className='btn btn-warning' onClick={() => { handleOpenActualizar(m) }}><Edit /></button></td>
                                </tr>
                            ) : (null)
                        ))}
                    </tbody>
                </table>
            </div>
            {modalActualizarPeriodo()}
        </Fragment>
    );
};


export default withRouter(ConfiguracionPeriodos)
